import React from 'react'
import { Tween } from 'react-gsap';
import img from '../asset/aa.png';

const Dinor = (props) => { 

    // props로 받아와서 speed 설정

    return ( 
        <>
            <div>
                <Tween
                    from={{ rotationY: 10, rotationZ: 10, x: 5, y: -10, scale: 1.1, transformOrigin: 'right bottom'}}
                    duration={props.spd}
                    repeat={-1}
                    yoyo={true}
                >
                    <img src={img} alt=""/>
                </Tween>   
            </div>
        </>
     );
}
 
export default Dinor;